// CÓDIGO 100% COMPLETO
import React from 'react';

const InputField = ({ label, name, value, onChange, placeholder, type = 'text', required = false }) => (
    <div>
        {label && <label htmlFor={name} className="block text-sm font-medium mb-1 text-gray-600 dark:text-gray-300">{label}</label>}
        <input
            id={name}
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            required={required}
            className="w-full p-3 text-gray-900 dark:text-white bg-gray-200/50 dark:bg-white/10 rounded-lg border border-gray-300 dark:border-white/30 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all duration-200"
        />
    </div>
);

export default InputField;